import React from 'react'

function WalletConnect() {
  return (
    <div>
        <div className='walletconn'>
        <div class="container">
        <h3><strong>To Sign Up: Connect Your Wallet</strong></h3>
        <div class="wallet-box mt-4">
            <h5><img src="wallet-icon.png" width="24"/> Wallet Connect</h5>
            <div class="mt-3 p-3 border rounded">
                <img src="metamask-icon.png" width="30"/> Metamask
            </div>
            <button class="btn btn-cancel mt-4">Cancel</button>
        </div>
    </div>
        </div>
    </div>
  )
}

export default WalletConnect